import { Injectable } from "@angular/core";
import { Adapter } from "../../adapter";

export class BoilerSearch {
    constructor(
        public boilerId: number,
        public boilerName: string,
        public areaId: string,
        public areaName: string,
        public unitId: string,
        public unitName: string,
        public plantId: string,
        public plantName: string,
        public manufacturerId: string,
        public manufacturerName: string,
        public companyId: string,
        public ownerName: string,
        public boilerTypeId: string,
        public boilerTypeName: string,
        public boilerStatus: string,
        public model: string,
        public sicCode: string,
        public recordStatusDesc: string,
        public qcDate: string
    ) { }
}


@Injectable({
    providedIn: 'root',
})
export class BoilerSearchAdapter implements Adapter<BoilerSearch> {
    adapt(item: any): BoilerSearch {
        return new BoilerSearch(
            item.BOILER_ID, 
            item.NAME, 
            item.AREA_ID, 
            item.AREA_NAME,
            item.UNIT_ID, 
            item.UNIT_NAME,  
            item.PLANT_ID, 
            item.PLANT_NAME, 
            item.MANUFACTURER_ID, 
            item.MANUFACTURER_NAME, 
            item.COMPANY_ID, 
            item.OWNER_NAME, 
            item.TYPE, 
            item.TYPE_DESCRIPTION, 
            item.BOILER_STATUS, 
            item.MODEL, 
            item.SIC_CODE ? `${item.SIC_CODE} - ${item.SIC_CODE_DESC}` : '',
            item.RECORD_STATUS_DESC, 
            item.QC_DATE
        );
    }
}
